import screen from './screen';
import print from './print';

var styles = function styles(colors, fonts) {
  return {
    screen: screen(colors, fonts),
    print: print()
  };
};

export default styles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle/es/themes/default/index.js
// module id = 352
// module chunks = 0